export const SOW_REVISION_STAGE = 'SOW Revision';
export const DRAW_REQUEST_STAGE = 'Draw Requested';
export const DRAW_INIT_STAGE = 'Draw Initiated';
export const DRAWS_PROCESS = 'Draws';
export const EXTENSION_PROCESS = 'Extensions';
export const DEFAULT_DRAW_TYPE = 'regular';
export const INSURANCE_DRAW_TYPE = 'insurance';
export const ON_HOLD = 'On Hold';
export const WIRE_SENT_DRAW_RESOLVED = 'Wire Sent/Draw Resolved';
export const INSURANCE_DRAW = 'Insurance Draw';